// Financial Year utility functions

export const getCurrentFinancialYear = () => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1; // 0-based to 1-based
  
  if (currentMonth >= 4) {
    // April to March - current FY
    return `${currentYear}-${(currentYear + 1).toString().substr(2)}`;
  } else {
    // January to March - previous FY
    return `${currentYear - 1}-${currentYear.toString().substr(2)}`;
  }
};

export const getQuarterDates = (financialYear, quarter) => {
  const startYear = parseInt(financialYear.split('-')[0]);
  
  const quarters = {
    1: { // Q1: Apr-Jun
      startDate: new Date(startYear, 3, 1), // April 1
      endDate: new Date(startYear, 5, 30)   // June 30
    },
    2: { // Q2: Jul-Sep
      startDate: new Date(startYear, 6, 1), // July 1
      endDate: new Date(startYear, 8, 30)   // September 30
    },
    3: { // Q3: Oct-Dec
      startDate: new Date(startYear, 9, 1), // October 1
      endDate: new Date(startYear, 11, 31)  // December 31
    },
    4: { // Q4: Jan-Mar
      startDate: new Date(startYear + 1, 0, 1), // January 1
      endDate: new Date(startYear + 1, 2, 31)   // March 31
    }
  };
  
  return quarters[quarter];
};

export const getFinancialYearDates = (financialYear) => {
  const startYear = parseInt(financialYear.split('-')[0]);
  return {
    startDate: new Date(startYear, 3, 1), // April 1
    endDate: new Date(startYear + 1, 2, 31) // March 31 next year
  };
};

export const getCurrentQuarter = () => {
  const now = new Date();
  const currentMonth = now.getMonth() + 1; // 0-based to 1-based
  
  if (currentMonth >= 4 && currentMonth <= 6) return 1; // Q1: Apr-Jun
  if (currentMonth >= 7 && currentMonth <= 9) return 2; // Q2: Jul-Sep
  if (currentMonth >= 10 && currentMonth <= 12) return 3; // Q3: Oct-Dec
  return 4; // Q4: Jan-Mar
};

export const formatFinancialYear = (financialYear) => {
  const [startYear, endYear] = financialYear.split('-');
  return `${startYear}-${endYear}`;
};

export const getFinancialYearsList = (yearsBack = 3) => {
  const currentFY = getCurrentFinancialYear();
  const currentStartYear = parseInt(currentFY.split('-')[0]);
  
  const years = [];
  for (let i = 0; i <= yearsBack; i++) {
    const startYear = currentStartYear - i;
    const endYear = startYear + 1;
    years.push(`${startYear}-${endYear.toString().substr(2)}`);
  }
  
  return years;
};
